/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { observer } from 'mobx-react-lite'
import { useMobxStore } from 'src/state'
import failed from './failed.svg'
import { useMemo } from 'react'
import colors from '@sportninja/common/constants/appColors'

export const RegistrationFailed = observer(() => {
  const {
    registrationInvite: {
      state: { error, eventInfo },
      pushToStep,
    },
  } = useMobxStore()

  const isDarkMode = useMemo(
    () => eventInfo?.registration?.dark_theme,
    [eventInfo?.registration?.dark_theme]
  )

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 40px;
      `}
    >
      <div
        css={css`
          height: 180px;
          width: 240px;
        `}
      >
        <img src={failed} alt='failed' />
      </div>
      <h1
        css={css`
          color: ${isDarkMode ? colors.DEFAULT_FLAIR : colors.HEADER};
          text-align: center;
          font-family: Rift, sans-serif;
          font-size: 40px;
          font-style: normal;
          font-weight: 700;
          line-height: 100%; /* 40px */
          letter-spacing: 0.6px;
          text-transform: uppercase;
          margin: 28px 0;
        `}
      >
        SOMETHING WENT WRONG
      </h1>
      <p
        css={css`
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
        `}
      >
        {error}
      </p>
      <button
        onClick={() => pushToStep(0)}
        css={css`
          display: flex;
          width: 100%;
          margin-top: 24px;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 8px 0;
          margin-left: 8px;
          flex: 1;
          height: 40px;
          border: 2px solid #3f4753;
          color: ${isDarkMode ? 'white' : colors.HEADER};
          border-radius: 4px;
          font-size: 18px;
          font-weight: 700;
          font-family: Rift, sans-serif;
        `}
      >
        BACK
      </button>
    </div>
  )
})
